import React from 'react';

const EnglishConversationIframe = () => {
  return (
    <div style={{
      width: '100%',
      height: '100vh',
      margin: 0,
      padding: 0,
      overflow: 'hidden'
    }}>
      <iframe
        src="https://english-speak-ferret.vercel.app/"
        title="English Conversation Practice"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0
        }}
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
};

export default EnglishConversationIframe; 